module.exports = __webpack_public_path__ + "img/china.04715930.svg";